import * as React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Box, Typography } from '@mui/material';
import { colors } from '../Incidents/charts/colorsPalettes';

const sizing = {
  margin: { right: 5 },
  width: 400,
  height: 400,
  legend: { hidden: true },
};

export default function ReportsPieChart({ data }) {
  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  const getArcLabel = (params) => {
    const percent = params.value / TOTAL;
    return percent >= 0.05 ? `${(percent * 100).toFixed(0)}%` : '';
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box>
        <PieChart
          colors={colors}
          series={[
            {
              innerRadius: 120,
              outerRadius: 180,
              data,
              arcLabel: getArcLabel,
            },
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'white',
              fontSize: 14,
            },
          }}
          skipAnimation={true}
          {...sizing}
        />
      </Box>
      <Box
        display="flex"
        justifyContent="start"
        flexWrap="wrap"
        sx={{ width: 'fit-content' }}
      >
        {[
          data.slice(0, Math.ceil(data.length / 2)),
          data.slice(Math.ceil(data.length / 2)),
        ].map((columnData, colIndex) => (
          <Box key={colIndex} mx={2}>
            {columnData.map((item, index) => {
              const globalIndex = colIndex * Math.ceil(data.length / 2) + index;
              return (
                <Box
                  key={item.label}
                  display="flex"
                  alignItems="center"
                  mb={1}
                  // className="w-100"
                >
                  <Box
                    sx={{
                      width: 14,
                      height: 14,
                      backgroundColor: colors[globalIndex % colors.length],
                      borderRadius: '30%',
                      marginRight: 1,
                    }}
                  />
                  <Typography variant="body2" color="text.primary">
                    {item.label}: {'$' + item.value} (
                    {((item.value / TOTAL) * 100).toFixed(1) + '%'})
                  </Typography>
                </Box>
              );
            })}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
